// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__pvaGG","resendInfoText":"OnGoingPaymentBox_resendInfoText__3Bx19"};